/* eslint-disable camelcase */

import { useMemo } from 'react';
import { PlanRepository } from '@hotjar/webapp/domains/revenue/plan/plan-repository';
import { useSettings } from './useSettings';

export function usePlanRepository(): PlanRepository {
  const { data: settings } = useSettings();

  return useMemo(() => {
    const { available_plans = [] } = settings ?? {};
    const planRepository = new PlanRepository(available_plans);
    return planRepository;
  }, [settings]);
}
